import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { GridSettings } from '../model/grid-settings';

const getCircularReplacer = () =>
{
    const seen = new WeakSet();
    return (key, value) =>
    {
        if (typeof value === 'object' && value !== null)
        {
            if (seen.has(value))
            {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};

@Injectable()
export class GridStatePersistingService
{
    constructor(private localStorageService: LocalStorageService)
    {
    }

    public get<T>(token: string): T
    {
        const settings = this.localStorageService.retrieve(token);
        return settings ? JSON.parse(settings) : settings;
    }

    public set(token: string, gridConfig: GridSettings): void
    {
        this.localStorageService.store(token, JSON.stringify(gridConfig, getCircularReplacer()));
    }

    public delete(token: string): void
    {
        this.localStorageService.clear(token);
    }
}
